import * as React from "react";

const LogoSVG = (props) => {
    const colors = {
        lightBlue: "#e1eaf9",
        lightLavendar: "#a9a5d2",
        lavendar: "#6260ab",
        orange: "#E75C3F",
        violet: "#C3A2CC",
        yellow: "#EFBF48",
        teal: "#A0D1CE",
    };

    return (
        <svg id="momatu-logo-animation-components" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1080" {...props}>
            <defs>
                <clipPath id="clip-path">
                    <path className="cls-1" d="M949 611l23.53 6.5-6.87-100.09-23.53-6.16z" />
                </clipPath>
                <clipPath id="clip-path-2">
                    <path className="cls-1" d="M894.37 611l23.44 6.5-59.39-842.64h-23.33z" />
                </clipPath>
                <clipPath id="clip-path-3">
                    <path className="cls-1" d="M1001.68 611l23.36 6.5-20.62-67.5-23.53-6.16z" />
                </clipPath>
                <clipPath id="clip-path-4">
                    <path className="cls-1" d="M917.81 617.53L894.38 611l47.75-99.75 23.53 6.16z" />
                </clipPath>
                <clipPath id="clip-path-5">
                    <path className="cls-1" d="M1025 617.53l-23.36-6.5 9.79-23.95 23.57 7.52z" />
                </clipPath>
                <clipPath id="clip-path-6">
                    <path className="cls-1" d="M890 640h140v30H890z" />
                </clipPath>
                <clipPath id="clip-path-7">
                    <path className="cls-1" d="M972.53 617.53L949 611l31.89-67.17 23.53 6.16z" />
                </clipPath>
                <style>
                    {`
            .cls-1,.logo-top-line{
              fill:none
            }
            .logo-top-line{
              stroke-miterlimit:10;
              stroke-width:4px
            }
            .cls-4{
              fill:#afafaf
            }
            .cls-5{
              fill:#6d6c6c
            }
            .logo-top-line{
              stroke:${colors.orange}
            }
            .momatu-logo-letter{
              fill:${colors.orange};
              fill-rule:evenodd;
            }
            .logo-line{
              stroke: ${colors.orange};
              stroke-miterlimit:10;
              fill:none;
            }  
            .outroLine{
                stroke-width:24px
            }
            .timeline-line{
              fill: none;
            //   stroke: "#e1eaf9";
              stroke-miterlimit: 10;
              stroke-width: 10px;
            }
            `}
                </style>
            </defs>

            <g className="timeline-line-wrapper">
                <path
                    stroke={colors.lightBlue}
                    className="timeline-line"
                    d="M0,540.34c202,0,321.67-93.11,534.5-93.11,329.88,0,494.82,199.53,795.44,199.53S1920,471.18,2205.18,471.18s497.49,69.16,674.82,69.16c202,0,321.67-93.11,534.5-93.11,329.88,0,494.82,199.53,795.44,199.53S4800,471.18,5085.18,471.18s554.2,69.16,674.82,69.16"
                />
            </g>
            <g className="logo-wrapper">
                <path className="logo-speed-line-3" strokeWidth={4} strokeMiterlimit={10} stroke={colors.violet} fill="none" d="M970.43 518.01l10.46 99.52" />
                <path className="logo-speed-line-5" stroke={colors.teal} strokeWidth={4} strokeMiterlimit={10} fill="none" d="M1011.26 552.34l20.01 65.19" />

                <g clipPath="url(#clip-path)">
                    <path className="logo-line-3" strokeWidth={60} strokeMiterlimit={10} stroke={colors.yellow} fill="none" d="M946.05 610.79l24.38-92.78" />
                </g>
                <g clipPath="url(#clip-path-2)">
                    <path className="logo-line-1" strokeWidth={100} stroke={colors.violet} strokeMiterlimit={10} fill="none" d="M874.76-225.14v842.67" />
                </g>
                <g clipPath="url(#clip-path-3)">
                    <path className="logo-line-5" strokeWidth={70} stroke={colors.teal} strokeMiterlimit={10} fill="none" d="M1012.14 551.78l-15.74 58.64" />
                </g>
                <g clipPath="url(#clip-path-4)">
                    <path className="logo-line logo-line-2" strokeWidth={50} d="M909.27 616.25l37.89-105.97" />
                </g>
                <g clipPath="url(#clip-path-6)" id="logo-text">
                    <path
                        className="momatu-logo-letter momatu-logo-letter-1"
                        d="M916.31 646.4a7.19 7.19 0 012.74.5 5.73 5.73 0 012 1.41 6 6 0 011.26 2.17 8.73 8.73 0 01.44 2.84V664h-4.68v-10a3.4 3.4 0 00-.83-2.45 2.85 2.85 0 00-2.21-.89 3 3 0 00-2.29.89 3.23 3.23 0 00-.86 2.34V664h-4.67v-10a3.44 3.44 0 00-.83-2.45 3.31 3.31 0 00-4.52 0 3.37 3.37 0 00-.85 2.45v10h-4.68v-17.22h4.3v1.53a5.94 5.94 0 012.08-1.41 7.09 7.09 0 012.77-.51 6.62 6.62 0 013 .64 5.34 5.34 0 012.06 1.83 7.58 7.58 0 012.46-1.79 7.66 7.66 0 013.31-.67z"
                    />
                    <path
                        className="momatu-logo-letter momatu-logo-letter-2"
                        d="M934.77 646.39a9.4 9.4 0 016.5 2.59 9.07 9.07 0 012 2.84 8.66 8.66 0 01.73 3.54 8.82 8.82 0 01-.73 3.56 9 9 0 01-2 2.85 9.49 9.49 0 01-10.09 1.89 9.3 9.3 0 01-2.92-1.89 8.63 8.63 0 01-2-2.85 9 9 0 01-.71-3.56 8.81 8.81 0 01.71-3.54 8.65 8.65 0 012-2.84 9.5 9.5 0 012.9-1.89 9.15 9.15 0 013.61-.7zm0 4.28a4.13 4.13 0 00-3.21 1.34 4.85 4.85 0 00-1.22 3.39 4.71 4.71 0 001.22 3.35 4.21 4.21 0 003.21 1.3 4.39 4.39 0 001.74-.34 4.33 4.33 0 001.41-1 4.77 4.77 0 00.93-1.48 4.93 4.93 0 00.35-1.86 5 5 0 00-.35-1.88 4.59 4.59 0 00-.93-1.49 4.46 4.46 0 00-1.41-1 4.24 4.24 0 00-1.74-.33z"
                    />
                    <path
                        className="momatu-logo-letter momatu-logo-letter-3"
                        d="M966.86 646.4a7.18 7.18 0 012.73.5 5.73 5.73 0 012 1.41 6 6 0 011.27 2.17 8.73 8.73 0 01.43 2.84V664h-4.67v-10a3.44 3.44 0 00-.83-2.45 2.87 2.87 0 00-2.22-.89 3 3 0 00-2.28.89 3.19 3.19 0 00-.87 2.34V664h-4.67v-10a3.4 3.4 0 00-.83-2.45 2.89 2.89 0 00-2.25-.89 3 3 0 00-2.27.89 3.41 3.41 0 00-.85 2.45v10h-4.67v-17.22h4.29v1.53a6 6 0 012.08-1.41 7.09 7.09 0 012.77-.51 6.67 6.67 0 013 .64 5.42 5.42 0 012.06 1.83 7.54 7.54 0 012.45-1.79 7.71 7.71 0 013.33-.67z"
                    />
                    <path
                        className="momatu-logo-letter momatu-logo-letter-4"
                        d="M984.82 646.39a9.13 9.13 0 013 .47 6.15 6.15 0 013.82 3.68 8.79 8.79 0 01.54 3.22V664h-4.28v-1.67a6.44 6.44 0 01-2.23 1.52 7.65 7.65 0 01-3 .56 7.19 7.19 0 01-2.49-.4 5.68 5.68 0 01-1.87-1.08 4.4 4.4 0 01-1.16-1.61 5.13 5.13 0 01-.4-2 4.35 4.35 0 011.75-3.69 7.71 7.71 0 014.76-1.32h4.29v-.76a3 3 0 00-.79-2.23 3.3 3.3 0 00-2.42-.8 4.61 4.61 0 00-2.41.63 10.72 10.72 0 00-2.13 1.73l-2.39-2.88a9.21 9.21 0 017.41-3.61zm-.93 14.61a3.7 3.7 0 002.57-.94 3.1 3.1 0 001.06-2.46v-.21h-3.67c-1.6 0-2.39.58-2.39 1.73a1.6 1.6 0 00.67 1.39 2.93 2.93 0 001.76.49z"
                    />
                    <path className="momatu-logo-letter momatu-logo-letter-5" d="M1007.15 650.73h-4.88v6.78a2.48 2.48 0 00.78 2.09 4 4 0 002.41.59h1l1.25-.1V664c-.49.11-1 .21-1.53.29a11.39 11.39 0 01-1.69.12 7.53 7.53 0 01-5-1.56 6.12 6.12 0 01-1.83-4.9v-7.2h-2.7v-4h2.7v-4.34h4.68v4.34h4.88v4z" />
                    <path
                        className="momatu-logo-letter momatu-logo-letter-6"
                        d="M1026.64 656.39a8.93 8.93 0 01-.6 3.32 7.4 7.4 0 01-1.67 2.52 7.06 7.06 0 01-2.49 1.6 8.94 8.94 0 01-6.23 0 7.06 7.06 0 01-2.49-1.6 7.48 7.48 0 01-1.66-2.52 8.54 8.54 0 01-.61-3.32v-9.62h4.64v10a3.18 3.18 0 00.93 2.41 3.27 3.27 0 002.32.89 3.21 3.21 0 002.29-.89 3.13 3.13 0 00.93-2.41v-10h4.64v9.62z"
                    />
                </g>

                <path className="logo-line outroLine" d="M1013,615.48s2.64-8.16,9.14-25.31c28.27-74.63,86.69-135.73,185.45-114.78,121,25.67,175.92,179.26,337.53,179.26C1691.74,654.65,1773.55,540,1920,540h34.67" />

                <g clipPath="url(#clip-path-7)">
                    <path className="logo-line logo-line-4" strokeWidth={40} d="M968.13 617.49l19.16-72.45" />
                </g>
                <path className="logo-top-line logo-speed-line-2" d="M891.25 602.83l52.88-107.4" />
                <path className="logo-top-line logo-speed-line-4" d="M948.46 597.56l32.73-66.46" />
            </g>
        </svg>
    );
};

export default LogoSVG;
